
// Copied from:
// https://stackoverflow.com/questions/13627308

export const ordinalSuffix = (n: number): string => {
	const m10 = n % 10;
	const m100 = n % 100;

	if (m10 === 1 && m100 !== 11) {
		return 'st';
	} else if (m10 === 2 && m100 !== 12) {
		return 'nd';
	} else if (m10 === 3 && m100 !== 13) {
		return 'rd';
	}

	return 'th';
};
